// Destroyer Shopify JS — Multilingual Edition (DE / IT / EN)

// ─── LOCALE ──────────────────────────────────────────────────
function getLocale() {
  const p = window.location.pathname;
  if (p.startsWith('/it')) return 'it';
  if (p.startsWith('/en')) return 'en';
  return 'de';
}
const LOCALE = getLocale();

// ─── ICONS ───────────────────────────────────────────────────
const ICON_STRETCH = `<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M8 24 L40 24 M24 8 L24 40 M12 12 L36 36 M36 12 L12 36"/></svg>`;
const ICON_STAR    = `<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="24,4 30,18 44,18 33,27 37,42 24,33 11,42 15,27 4,18 18,18"/></svg>`;
const ICON_LOCK    = `<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="12" y="20" width="24" height="20" rx="2"/><path d="M17 20v-5a7 7 0 0114 0v5"/><circle cx="24" cy="31" r="3"/></svg>`;
const ICON_POCKET  = `<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="10" width="14" height="12" rx="1"/><rect x="26" y="10" width="14" height="12" rx="1"/><rect x="8" y="26" width="14" height="12" rx="1"/><rect x="26" y="26" width="14" height="12" rx="1"/></svg>`;
const ICON_CLOCK   = `<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="24" cy="24" r="18"/><path d="M24 14v10l6 4"/></svg>`;
const ICON_PERSON  = `<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="24" cy="14" r="6"/><path d="M10 40c0-7.7 6.3-14 14-14s14 6.3 14 14"/><path d="M6 20l4 4-4 4"/><path d="M42 20l-4 4 4 4"/></svg>`;

// ─── FEATURES ─────────────────────────────────────────────────
const FEATURES_DATA = {
  de: [
    { title: 'STRETCH DENIM',      desc: '4-Wege-Stretch-Denim für maximale Bewegungsfreiheit — kein Einschränken mehr beim Pedaleinsatz.', icon: ICON_STRETCH },
    { title: 'EXTREME HALTBARKEIT',desc: 'Dreifachgenähte Nähte, verstärkte Knie- und Gesässpanelen für den härtesten Einsatz.', icon: ICON_STAR },
    { title: 'MTB VERSCHLUSS',     desc: 'Spezial-Knopf-System mit Anti-Öffnungs-Mechanismus — bleibt zu, egal wie hart der Drop.', icon: ICON_LOCK },
    { title: '4-POCKET SYSTEM',    desc: 'Tiefe Taschen mit Reißverschlüssen — kein Phone verloren, auch nicht auf 40km/h Singletrail.', icon: ICON_POCKET },
    { title: 'RACE TESTED',        desc: '2× Ital. Downhill-Meisterschaft, hunderte Rennen, tausende Trails — echte Validation.', icon: ICON_CLOCK },
    { title: 'ALL-DAY STYLE',      desc: 'Vom Trail in die Bar. Destroyer sieht gut aus — auf dem Bike und danach.', icon: ICON_PERSON }
  ],
  it: [
    { title: 'STRETCH DENIM',        desc: 'Denim elasticizzato a 4 vie per la massima libertà di movimento — mai più limitazioni in pedalata.', icon: ICON_STRETCH },
    { title: 'ESTREMA DURABILITÀ',   desc: 'Cuciture triple, rinforzi su ginocchia e glutei per il più intenso utilizzo.', icon: ICON_STAR },
    { title: 'CHIUSURA MTB',         desc: 'Sistema di bottoni speciale con meccanismo anti-apertura — rimane chiuso, qualunque sia il drop.', icon: ICON_LOCK },
    { title: 'SISTEMA 4 TASCHE',     desc: 'Tasche profonde con cerniere — nessun telefono perso, nemmeno a 40km/h su singletrace.', icon: ICON_POCKET },
    { title: 'RACE TESTED',          desc: '2× Campionato Italiano di Downhill, centinaia di gare, migliaia di trail — vera validazione.', icon: ICON_CLOCK },
    { title: 'STILE TUTTO IL GIORNO',desc: 'Dal trail al bar. Destroyer si veste bene — in bici e dopo.', icon: ICON_PERSON }
  ],
  en: [
    { title: 'STRETCH DENIM',     desc: '4-way stretch denim for maximum freedom of movement — no more restriction while pedaling.', icon: ICON_STRETCH },
    { title: 'EXTREME DURABILITY',desc: 'Triple stitching, reinforced knee and seat panels for the hardest use.', icon: ICON_STAR },
    { title: 'MTB CLOSURE',       desc: 'Special button system with anti-opening mechanism — stays closed, no matter how hard the drop.', icon: ICON_LOCK },
    { title: '4-POCKET SYSTEM',   desc: 'Deep pockets with zippers — no phone lost, even at 40km/h on singletrack.', icon: ICON_POCKET },
    { title: 'RACE TESTED',       desc: '2× Italian Downhill Championship, hundreds of races, thousands of trails — real validation.', icon: ICON_CLOCK },
    { title: 'ALL-DAY STYLE',     desc: 'From trail to bar. Destroyer looks great — on the bike and after.', icon: ICON_PERSON }
  ]
};

// ─── COMPARE ──────────────────────────────────────────────────
const COMPARE_HEADERS = {
  de: ['Eigenschaft',    'DESTROYER JEANS', 'Normale Jeans',  'MTB Racehose'],
  it: ['Caratteristica', 'DESTROYER JEANS', 'Jeans Normali',  'Pantaloni MTB'],
  en: ['Feature',        'DESTROYER JEANS', 'Regular Jeans',  'MTB Race Pants']
};

const COMPARE_ROWS_DATA = {
  de: [
    ['Stretch-Denim Stoff',       true, true,  false],
    ['Race-getestet',             true, false, true],
    ['All-Day-Tauglichkeit',      true, true,  false],
    ['MTB-Spezial-Schnitt',       true, false, true],
    ['Reißverschluss-Taschen',    true, false, true],
    ['Style auf der Straße',      true, true,  false],
    ['Knie-Paneel-Verstärkung',   true, false, true],
    ['Waschmaschinengeeignet',    true, true,  false]
  ],
  it: [
    ['Tessuto Stretch Denim',        true, true,  false],
    ['Testato in gara',              true, false, true],
    ['Uso tutto il giorno',          true, true,  false],
    ['Taglio speciale MTB',          true, false, true],
    ['Tasche con cerniera',          true, false, true],
    ['Stile in città',               true, true,  false],
    ['Rinforzo pannello ginocchio',  true, false, true],
    ['Lavabile in lavatrice',        true, true,  false]
  ],
  en: [
    ['Stretch Denim Fabric',      true, true,  false],
    ['Race-tested',               true, false, true],
    ['All-Day Wearability',       true, true,  false],
    ['MTB-Specific Cut',          true, false, true],
    ['Zip Pockets',               true, false, true],
    ['Street Style',              true, true,  false],
    ['Knee Panel Reinforcement',  true, false, true],
    ['Machine Washable',          true, true,  false]
  ]
};

// ─── FAQS ─────────────────────────────────────────────────────
const FAQS_DATA = {
  de: [
    ['Sind Destroyer MTB Jeans wirklich für Downhill geeignet?',
     'Ja. Destroyer Jeans wurden von 2× Ital. Downhill-Meister Johannes von Klebelsberg entwickelt und race-getestet. Stretch-Denim mit MTB-spezifischem Schnitt und verstärkten Nähten.'],
    ['Welche Größen gibt es?',
     'Destroyer Jeans sind in den Größen 28–38 erhältlich. Unser MTB-Schnitt sitzt auch bei voller Bewegungsfreiheit auf dem Bike perfekt.'],
    ['Kann ich Destroyer Jeans auch im Alltag tragen?',
     'Absolut. All-Day-Style ist ein Kernprinzip von Destroyer. Du kannst vom Trail direkt in die Bar — kein Umziehen nötig.'],
    ['Wie pflege ich meine Destroyer Jeans?',
     'Maschinenwäsche 30°C, links waschen, nicht trocknen – so bleibt die Farbe satt und der Stretch erhalten.'],
    ['Wie lange ist die Lieferzeit?',
     'D/A/CH: 3–5 Werktage. EU: 5–10 Werktage. Versand aus Bolzano, Südtirol.'],
    ['Gibt es eine Größenberatung?',
     'Ja! Schreib uns direkt auf Instagram oder per E-Mail. Johannes und sein Team helfen dir persönlich bei der Größenwahl.']
  ],
  it: [
    ['I jeans Destroyer MTB sono adatti al Downhill?',
     'Sì. I jeans Destroyer sono stati sviluppati e testati in gara dal 2× Campione Italiano di Downhill Johannes von Klebelsberg. Denim elasticizzato con taglio MTB specifico e cuciture rinforzate.'],
    ['Quali taglie sono disponibili?',
     'I jeans Destroyer sono disponibili nelle taglie 28–38. Il nostro taglio MTB si adatta perfettamente anche con la massima libertà di movimento in bici.'],
    ['Posso indossare i jeans Destroyer nella vita quotidiana?',
     'Assolutamente. Lo stile tutto il giorno è un principio fondamentale di Destroyer. Puoi andare direttamente dal trail al bar — senza cambiarsi.'],
    ['Come curo i miei jeans Destroyer?',
     'Lavaggio in lavatrice a 30°C, lavare al rovescio, non asciugare in asciugatrice — così il colore rimane vivido e lo stretch si mantiene.'],
    ['Quali sono i tempi di consegna?',
     'Italia: 3–5 giorni lavorativi. EU: 5–10 giorni lavorativi. Spedizione da Bolzano, Alto Adige.'],
    ['È disponibile una consulenza sulle taglie?',
     'Sì! Scrivici su Instagram o via email. Johannes e il suo team ti aiuteranno personalmente nella scelta della taglia.']
  ],
  en: [
    ['Are Destroyer MTB jeans really suitable for Downhill?',
     'Yes. Destroyer jeans were developed and race-tested by 2× Italian Downhill Champion Johannes von Klebelsberg. Stretch denim with MTB-specific cut and reinforced seams.'],
    ['What sizes are available?',
     'Destroyer jeans are available in sizes 28–38. Our MTB cut fits perfectly even with full freedom of movement on the bike.'],
    ['Can I wear Destroyer jeans in everyday life?',
     'Absolutely. All-day style is a core principle of Destroyer. You can go straight from the trail to the bar — no need to change.'],
    ['How do I care for my Destroyer jeans?',
     'Machine wash at 30°C, wash inside out, do not tumble dry — this keeps the colour rich and the stretch intact.'],
    ['What are the delivery times?',
     'D/A/CH: 3–5 working days. EU: 5–10 working days. Shipped from Bolzano, South Tyrol.'],
    ['Is sizing advice available?',
     'Yes! Write to us on Instagram or by email. Johannes and his team will personally help you choose your size.']
  ]
};

// ─── UI TRANSLATIONS ──────────────────────────────────────────
const T = {
  de: {
    cartTitle:             'WARENKORB',
    cartEmpty:             'Dein Warenkorb ist noch leer.',
    cartTotal:             'GESAMT',
    cartCheckout:          'ZUR KASSE →',
    cartRemove:            'Entfernen',
    sizeTitle:             'GRÖSSE WÄHLEN',
    sizeAddBtn:            'IN DEN WARENKORB',
    quickAdd:              'Schnell hinzufügen',
    toastAdded:            'Zum Warenkorb hinzugefügt',
    selectSize:            'Bitte Größe wählen!',
    addedSuffix:           'hinzugefügt',
    errorCartAdd:          'Produkt konnte nicht in den Warenkorb gelegt werden.',
    errorCartUpdate:       'Warenkorb konnte nicht aktualisiert werden.',
    errorCartLoad:         'Cart konnte nicht geladen werden.',
    errorVariantsNotFound: 'Varianten konnten nicht gefunden werden.',
    errorVariantsNotRead:  'Varianten konnten nicht gelesen werden.',
    badge0: 'BESTSELLER', badge1: 'NEU', badge2: 'PRO',
    marquee: ['MTB JEANS','DOWNHILL JEANS','FREERIDE JEANS','DOLOMITEN','RACE TESTED','ALL-DAY STYLE','STRETCH DENIM','BOLZANO','MTB DENIM','DESTROYER BRAND']
  },
  it: {
    cartTitle:             'CARRELLO',
    cartEmpty:             'Il tuo carrello è vuoto.',
    cartTotal:             'TOTALE',
    cartCheckout:          'VAI ALLA CASSA →',
    cartRemove:            'Rimuovi',
    sizeTitle:             'SCEGLI LA TAGLIA',
    sizeAddBtn:            'AGGIUNGI AL CARRELLO',
    quickAdd:              'Aggiunta rapida',
    toastAdded:            'Aggiunto al carrello',
    selectSize:            'Seleziona una taglia!',
    addedSuffix:           'aggiunto',
    errorCartAdd:          'Impossibile aggiungere il prodotto al carrello.',
    errorCartUpdate:       'Impossibile aggiornare il carrello.',
    errorCartLoad:         'Impossibile caricare il carrello.',
    errorVariantsNotFound: 'Varianti non trovate.',
    errorVariantsNotRead:  'Impossibile leggere le varianti.',
    badge0: 'BESTSELLER', badge1: 'NUOVO', badge2: 'PRO',
    marquee: ['MTB JEANS','DOWNHILL JEANS','FREERIDE JEANS','DOLOMITI','RACE TESTED','STILE TUTTO IL GIORNO','STRETCH DENIM','BOLZANO','MTB DENIM','DESTROYER BRAND']
  },
  en: {
    cartTitle:             'CART',
    cartEmpty:             'Your cart is empty.',
    cartTotal:             'TOTAL',
    cartCheckout:          'CHECKOUT →',
    cartRemove:            'Remove',
    sizeTitle:             'SELECT SIZE',
    sizeAddBtn:            'ADD TO CART',
    quickAdd:              'Quick add',
    toastAdded:            'Added to cart',
    selectSize:            'Please select a size!',
    addedSuffix:           'added',
    errorCartAdd:          'Could not add product to cart.',
    errorCartUpdate:       'Could not update cart.',
    errorCartLoad:         'Could not load cart.',
    errorVariantsNotFound: 'Variants could not be found.',
    errorVariantsNotRead:  'Variants could not be read.',
    badge0: 'BESTSELLER', badge1: 'NEW', badge2: 'PRO',
    marquee: ['MTB JEANS','DOWNHILL JEANS','FREERIDE JEANS','DOLOMITES','RACE TESTED','ALL-DAY STYLE','STRETCH DENIM','BOLZANO','MTB DENIM','DESTROYER BRAND']
  }
};

let pendingVariantId    = null;
let pendingVariantTitle = null;

// ─── HELPERS ──────────────────────────────────────────────────
function shopRoot() {
  return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
    ? window.Shopify.routes.root
    : '/';
}

function formatMoney(cents) {
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents);
  }
  return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
}

function getVariantLabel(variant) {
  if (!variant) return '';
  if (variant.title && variant.title !== 'Default Title') return variant.title;
  return variant.option1 || variant.name || 'Standard';
}

function escapeHtml(str) {
  return String(str || '').replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));
}

// ─── SHOPIFY CART API ─────────────────────────────────────────
async function fetchCart() {
  const res = await fetch(shopRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } });
  if (!res.ok) throw new Error(T[LOCALE].errorCartLoad);
  return res.json();
}

async function addVariantToCart(variantId, quantity = 1) {
  const res = await fetch(shopRoot() + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity) })
  });
  if (!res.ok) {
    let msg = T[LOCALE].errorCartAdd;
    try { const e = await res.json(); msg = e.description || e.message || msg; } catch (_) {}
    throw new Error(msg);
  }
  return res.json();
}

async function changeCartLine(key, quantity) {
  const res = await fetch(shopRoot() + 'cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity: Number(quantity) })
  });
  if (!res.ok) throw new Error(T[LOCALE].errorCartUpdate);
  return res.json();
}

async function addToCartForm(form) {
  const fd = new FormData(form);
  try {
    await addVariantToCart(fd.get('id'), fd.get('quantity') || 1);
    await updateCartUI();
    showToast(T[LOCALE].toastAdded);
    openCart();
  } catch (err) {
    showToast(err.message);
  }
}

async function updateCartUI() {
  const cart = await fetchCart();
  const t    = T[LOCALE];

  const badge = document.getElementById('cart-badge');
  const total = document.getElementById('cart-total-price');
  const empty = document.getElementById('cart-empty');
  const list  = document.getElementById('cart-items-list');

  if (badge) badge.textContent = cart.item_count;
  if (total) total.textContent = formatMoney(cart.total_price);
  if (!list || !empty) return;

  if (!cart.items || cart.items.length === 0) {
    empty.style.display = 'block';
    list.innerHTML = '';
    return;
  }

  empty.style.display = 'none';
  list.innerHTML = cart.items.map(item => {
    const img = item.image
      ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}">`
      : escapeHtml(item.product_title).slice(0, 7).toUpperCase();
    return `
      <div class="cart-item">
        <div class="cart-item-img">${img}</div>
        <div class="cart-item-info">
          <div class="cart-item-name">${escapeHtml(item.product_title)}</div>
          <div class="cart-item-size">${escapeHtml(item.variant_title || '')}</div>
          <div class="cart-item-row">
            <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
            <button class="cart-item-remove" type="button" onclick="removeCartLine('${item.key}')">
              ${t.cartRemove}
            </button>
          </div>
        </div>
      </div>`;
  }).join('');
}

async function removeCartLine(key) {
  try {
    await changeCartLine(key, 0);
    await updateCartUI();
  } catch (err) {
    showToast(err.message);
  }
}

// ─── CART DRAWER ──────────────────────────────────────────────
function openCart() {
  updateCartUI().catch(() => {});
  document.getElementById('cart-overlay')?.classList.add('open');
  document.getElementById('cart-drawer')?.classList.add('open');
}

function closeCart() {
  document.getElementById('cart-overlay')?.classList.remove('open');
  document.getElementById('cart-drawer')?.classList.remove('open');
}

// ─── SIZE MODAL ───────────────────────────────────────────────
function openSizeModalFromCard(button) {
  const card = button.closest('[data-product-card]');
  if (!card) return;

  const titleEl    = card.querySelector('[data-product-title]');
  const variantsEl = card.querySelector('[data-product-variants]');

  if (!variantsEl) { showToast(T[LOCALE].errorVariantsNotFound); return; }

  let variants = [];
  try { variants = JSON.parse(variantsEl.textContent); }
  catch (_) { showToast(T[LOCALE].errorVariantsNotRead); return; }

  pendingVariantId    = null;
  pendingVariantTitle = null;

  const modalTitle = document.getElementById('modal-product-name');
  const grid       = document.getElementById('size-grid');

  if (modalTitle) modalTitle.textContent = titleEl ? titleEl.textContent.trim() : 'Produkt';
  if (!grid) return;

  const real    = variants.filter(v => v.available);
  const visible = real.length ? real : variants;

  grid.innerHTML = visible.map(v => `
    <button
      class="size-btn"
      type="button"
      data-variant-id="${v.id}"
      data-variant-title="${escapeHtml(getVariantLabel(v))}"
      ${v.available ? '' : 'disabled'}
      onclick="selectVariantSize(this)"
    >${escapeHtml(getVariantLabel(v))}</button>
  `).join('');

  document.getElementById('size-modal')?.classList.add('open');
}

function closeSizeModal(event) {
  const modal = document.getElementById('size-modal');
  if (!modal) return;
  if (!event || event.target === modal) modal.classList.remove('open');
}

function forceCloseSizeModal() {
  document.getElementById('size-modal')?.classList.remove('open');
}

function selectVariantSize(btn) {
  pendingVariantId    = btn.dataset.variantId;
  pendingVariantTitle = btn.dataset.variantTitle;
  document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('selected'));
  btn.classList.add('selected');
}

async function addToCartFromModal() {
  if (!pendingVariantId) { showToast(T[LOCALE].selectSize); return; }
  try {
    await addVariantToCart(pendingVariantId, 1);
    forceCloseSizeModal();
    await updateCartUI();
    showToast(`${pendingVariantTitle || 'Produkt'} ${T[LOCALE].addedSuffix}`);
    openCart();
  } catch (err) {
    showToast(err.message);
  }
}

// ─── TOAST ────────────────────────────────────────────────────
let toastTimeout;
function showToast(msg) {
  const toast = document.getElementById('toast');
  const msgEl = document.getElementById('toast-msg');
  if (!toast || !msgEl) return;
  msgEl.textContent = msg;
  toast.classList.add('show');
  clearTimeout(toastTimeout);
  toastTimeout = setTimeout(() => toast.classList.remove('show'), 3200);
}

// ─── LANGUAGE SWITCHER ────────────────────────────────────────
function setLang(lang, btn) {
  document.querySelectorAll('.lang-switcher button').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  if (!['de', 'it', 'en'].includes(lang)) return;

  let path = window.location.pathname;
  path = path.replace(/^\/(it|en|de)(\/|$)/, '/');
  if (!path.startsWith('/')) path = '/' + path;

  const target = (lang === 'de')
    ? path + window.location.search
    : '/' + lang + path + window.location.search;

  window.location.href = target;
}

// ─── STATIC SECTIONS ──────────────────────────────────────────
function buildStaticSections() {
  const t       = T[LOCALE];
  const features = FEATURES_DATA[LOCALE];
  const rows     = COMPARE_ROWS_DATA[LOCALE];
  const headers  = COMPARE_HEADERS[LOCALE];
  const faqs     = FAQS_DATA[LOCALE];

  // Marquee
  const track = document.getElementById('marquee-track');
  if (track) {
    track.innerHTML = [...t.marquee, ...t.marquee].map(text => `
      <div class="marquee-item">
        <span class="marquee-text">${text}</span>
        <span class="marquee-dot"></span>
      </div>`).join('');
  }

  // Features grid
  const featuresGrid = document.getElementById('features-grid');
  if (featuresGrid) {
    featuresGrid.innerHTML = features.map(f => `
      <div class="feature-item reveal">
        <div class="feature-icon">${f.icon}</div>
        <div class="feature-title">${f.title}</div>
        <p class="feature-desc">${f.desc}</p>
      </div>`).join('');
  }

  // Compare: thead
  const thead = document.querySelector('.compare-table thead tr');
  if (thead) {
    thead.innerHTML = `
      <th style="width:36%">${headers[0]}</th>
      <th class="highlight">${headers[1]}</th>
      <th>${headers[2]}</th>
      <th>${headers[3]}</th>`;
  }

  // Compare: tbody
  const compareBody = document.getElementById('compare-body');
  if (compareBody) {
    compareBody.innerHTML = rows.map(row => `
      <tr>
        <td><span class="feat-label">${row[0]}</span></td>
        <td class="highlight">${row[1] ? '<span class="check-icon">✓</span>' : '<span class="x-icon">×</span>'}</td>
        <td>${row[2] ? '<span class="check-icon">✓</span>' : '<span class="x-icon">×</span>'}</td>
        <td>${row[3] ? '<span class="check-icon">✓</span>' : '<span class="x-icon">×</span>'}</td>
      </tr>`).join('');
  }

  // FAQs
  const faqList = document.getElementById('faq-list');
  if (faqList) {
    faqList.innerHTML = faqs.map((faq, i) => `
      <div class="faq-item">
        <div class="faq-q" onclick="toggleFaq(${i}, this)">
          <span>${faq[0]}</span>
          <span class="faq-icon">+</span>
        </div>
        <div class="faq-a" id="faq-a-${i}">${faq[1]}</div>
      </div>`).join('');
  }
}

function toggleFaq(index, questionElement) {
  const answer = document.getElementById(`faq-a-${index}`);
  const isOpen = answer && answer.classList.contains('open');
  document.querySelectorAll('.faq-a').forEach(el => el.classList.remove('open'));
  document.querySelectorAll('.faq-q').forEach(el => el.classList.remove('open'));
  if (!isOpen && answer) {
    answer.classList.add('open');
    questionElement.classList.add('open');
  }
}

// ─── CARD TILT ────────────────────────────────────────────────
function tiltCard(event, card) {
  const rect    = card.getBoundingClientRect();
  const rotateX = ((event.clientY - rect.top)  / rect.height - 0.5) * -6;
  const rotateY = ((event.clientX - rect.left) / rect.width  - 0.5) *  6;
  card.style.transform = `perspective(900px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-8px) scale(1.01)`;
}

function resetTilt(card) {
  card.style.transform = '';
}

// ─── ANIMATIONS ───────────────────────────────────────────────
function initAnimations() {
  if (typeof gsap === 'undefined') {
    document.getElementById('loader')?.style && (document.getElementById('loader').style.display = 'none');
    document.querySelectorAll('.reveal').forEach(el => { el.style.opacity = 1; el.style.transform = 'none'; });
    ['#ht1','#ht2','#ht3','#hero-sub','#hero-btns','#scroll-hint'].forEach(sel => {
      const el = document.querySelector(sel);
      if (el) { el.style.opacity = 1; el.style.transform = 'none'; }
    });
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  const tl = gsap.timeline({
    onComplete: () => {
      const loader = document.getElementById('loader');
      if (loader) loader.style.display = 'none';
      gsap.to('#hero-eyebrow', { opacity: 1, y: 0, duration: 0.5, delay: 0.1 });
      gsap.to(['#ht1','#ht2','#ht3'], { y: 0, stagger: 0.12, duration: 0.7, ease: 'power3.out', delay: 0.15 });
      gsap.to(['#hero-sub','#hero-btns','#scroll-hint'], { opacity: 1, y: 0, stagger: 0.12, duration: 0.6, ease: 'power2.out', delay: 0.55 });
    }
  });

  tl.to('#loader-word', { y: 0, opacity: 1, duration: 0.7, ease: 'power3.out' })
    .to('#loader-bar-wrap', { opacity: 1, duration: 0.3 }, 0.4)
    .to('#loader-bar', { width: '100%', duration: 1.2, ease: 'power2.inOut' }, 0.5)
    .add(() => {}, '+=0.3');

  if (document.getElementById('hero-parallax')) {
    gsap.to('#hero-parallax', { yPercent: 30, ease: 'none', scrollTrigger: { trigger: '#hero', start: 'top top', end: 'bottom top', scrub: true } });
  }
  if (document.getElementById('story-parallax')) {
    gsap.to('#story-parallax', { yPercent: 20, ease: 'none', scrollTrigger: { trigger: '#story', start: 'top bottom', end: 'bottom top', scrub: true } });
  }

  document.querySelectorAll('.reveal').forEach(el => {
    gsap.fromTo(el,
      { opacity: 0, y: 44 },
      { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out', scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none none' } }
    );
  });

  [0, 1, 2].forEach(i => {
    const el = document.getElementById(`stat${i}`);
    if (!el) return;
    const target = parseInt(el.dataset.target, 10);
    ScrollTrigger.create({
      trigger: el, start: 'top 85%', once: true,
      onEnter: () => {
        gsap.fromTo(el, { innerText: 0 }, {
          innerText: target, duration: 1.8, ease: 'power2.out',
          snap: { innerText: 1 },
          onUpdate: function() { el.textContent = Math.round(this.targets()[0].innerText); }
        });
      }
    });
  });
}

// ─── NAV ──────────────────────────────────────────────────────
function initNav() {
  let lastY = 0;
  window.addEventListener('scroll', () => {
    const y   = window.scrollY;
    const nav = document.getElementById('navbar');
    if (!nav) return;
    nav.classList.toggle('hidden', y > lastY && y > 120);
    lastY = y;
  }, { passive: true });
}

// ─── CURSOR ───────────────────────────────────────────────────
function initCursor() {
  const dot  = document.getElementById('cursor-dot');
  const ring = document.getElementById('cursor-ring');
  if (!dot || !ring || window.matchMedia('(max-width: 900px)').matches) return;

  let dotX = 0, dotY = 0, ringX = 0, ringY = 0;

  document.addEventListener('mousemove', e => {
    dotX = e.clientX; dotY = e.clientY;
    dot.style.left = dotX + 'px'; dot.style.top = dotY + 'px';
  });

  (function animateRing() {
    ringX += (dotX - ringX) * 0.12;
    ringY += (dotY - ringY) * 0.12;
    ring.style.left = ringX + 'px'; ring.style.top = ringY + 'px';
    requestAnimationFrame(animateRing);
  })();

  document.querySelectorAll('a, button, .product-card, .blog-card, .faq-q, .size-btn').forEach(el => {
    el.addEventListener('mouseenter', () => document.body.classList.add('cursor-hover'));
    el.addEventListener('mouseleave', () => document.body.classList.remove('cursor-hover'));
  });
}

// ─── INIT ─────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  // Add lang class to body for CSS locale overrides
  document.body.classList.add('lang-' + LOCALE);

  buildStaticSections();
  updateCartUI().catch(() => {});
  initNav();
  initCursor();

  // Set active language button based on current URL
  document.querySelectorAll('.lang-switcher button').forEach(btn => {
    btn.classList.remove('active');
    const m = btn.getAttribute('onclick')?.match(/setLang\('(\w+)'/);
    if (m?.[1] === LOCALE) btn.classList.add('active');
  });

  window.setTimeout(initAnimations, 120);
});